import { type QueryFunctionContext, useInfiniteQuery } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';

import { type ILocationsLogData, type IUseLocationsLogInfiniteListKeys } from '../model/locationsLog';

export const locationsLogListKey = (keys: IUseLocationsLogInfiniteListKeys): [string, number, string] => [
  'locationsLogList',
  keys?.perPage,
  keys?.searchValue,
];

export const locationsLogListFn = ({
  queryKey,
  pageParam = 1,
}: QueryFunctionContext<ReturnType<typeof locationsLogListKey>, number>) => {
  const params: {
    page: number;
    per_page: number;
    search_notes?: string;
  } = {
    page: pageParam,
    per_page: queryKey[1] || 20,
  };

  if (queryKey[2]) {
    params['search_notes'] = queryKey[2];
  }
  return apiClient
    .get<ILocationsLogData>(`${APP_API_URL}locations/log-data`, { params })
    .then((result) => result.data);
};

export const useLocationsLogListInfiniteQuery = (keys: IUseLocationsLogInfiniteListKeys) => {
  return useInfiniteQuery({
    queryKey: locationsLogListKey(keys),
    queryFn: locationsLogListFn,
    getNextPageParam: ({ data, currentPage }) => (data?.length ? currentPage + 1 : undefined),
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  });
};
